import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Api from "../../Config/Api";
import MasterApi from '../../Config/MasterApi'

export const insertIlustrationSignature = createAsyncThunk('signature/insertSignature', async(data)=>{
    return Api.post(Api.routeEapp+MasterApi.insertSignature, data)
    .then(response=>{
        return response
    })
    .catch(err=>{
        return err
    })
})

export const insertSelfie = createAsyncThunk('selfie/insertSelfie', async(data)=>{
    return Api.FormData(Api.routeOcr+MasterApi.insertSelfie, data)
    .then(response=>{
        return response
    })
    .catch(err=>{
        return err
    })
})

export const checkSelfieSignature = createAsyncThunk('signature/checkSelfieSignature', async(data)=>{
    return Api.post(Api.routeEapp+MasterApi.checkSelfieSignature, data)
    .then(response=>{
        return response
    })
    .catch(err=>{
        return err
    })
})

export const insertVideo = createAsyncThunk('video/insertVideo', async(data)=>{
    return Api.FormData(Api.routeEapp+MasterApi.insertVideo, data)
    .then(response=>{
        return response
    })
    .catch(err=>{
        return err
    })
})

export const convertVideo = createAsyncThunk('video/convertVideo', async(data)=>{
    return Api.FormData(Api.routeVidConvert+MasterApi.convertVideo, data)
    .then(response=>{
        return response
    })
    .catch(err=>{
        return err
    })
})

export const getIlustrationSignature = createAsyncThunk('signature/getSignature', async(data)=>{
    return Api.post(Api.routeEapp+MasterApi.getSignature, data)
    .then(response=>{
        return response
    })
    .catch(err=>{
        return err
    })
})

export const getSingleIlustrationSignature = createAsyncThunk('signature/getSingleSignature', async(data)=>{
    return Api.post(Api.routeEapp+MasterApi.getSingleSignature, data)
    .then(response=>{
        return response
    })
    .catch(err=>{
        return err
    })
})

export const getSelfie = createAsyncThunk('selfie/getSelfie',async(data)=>{
    return Api.post(Api.routeEapp+MasterApi.getSelfie,data)
    .then(response=>{
        return response
    })
    .catch(err=>{
        return err
    })
})

export const getVideos = createAsyncThunk('video/insertVideo', async(data)=>{
    return Api.post(Api.routeEapp+MasterApi.getVideo, data)
    .then(response=>{
        return response
    })
    .catch(err=>{
        return err
    })
})

export const getVideoPending = createAsyncThunk('video/pendingVideo', async(data)=>{
    return Api.post(Api.routeEapp+MasterApi.getVideoPending, data)
    .then(response=>{
        return response
    })
    .catch(err=>{
        return err
    })
})

export const updatePreambules = createAsyncThunk('video/updatePreambule', async(data)=>{
    return Api.post(Api.routeEapp+MasterApi.updatePreambule, data)
    .then(response=>{
        return response
    })
    .catch(err=>{
        return err
    })
})

export const getStatement = createAsyncThunk('video/statement', async(data)=>{
    return Api.post(Api.routeEapp+MasterApi.getStatement, data)
    .then(response=>{
        return response
    })
    .catch(err=>{
        return err
    })
})

export const getProductScript = createAsyncThunk('product/script', async(data)=>{
    return Api.post(Api.routeEapp+MasterApi.getProductScript, data)
    .then(response=>{
        return response
    })
    .catch(err=>{
        return err
    })
})

export const rejectVidPernyataan = createAsyncThunk('video/reject', async(data)=>{
    return Api.post(Api.routeEapp+MasterApi.rejectVidPernyataan, data)
    .then(response=>{
        return response
    })
    .catch(err=>{
        return err
    })
})

export const saveAnswer = createAsyncThunk('video/saveAnswer', async(data)=>{
    return Api.FormData(Api.routeVidConvert+MasterApi.saveAnswer, data)
    .then(response=>{
        return response
    })
    .catch(err=>{
        return err
    })
})

export const uploadDokumen = createAsyncThunk('dokumen/insertDokumen', async(data)=>{
    return Api.post(Api.routeEapp+MasterApi.insertDokumen, data)
    .then(response=>{
        return response
    })
    .catch(err=>{
        return err
    })
})


export const checkValid = createAsyncThunk('check/checkValid', async(data)=>{
    return Api.post(Api.routeEapp+MasterApi.checkValidasi, data)
    .then(response=>{
        return response
    })
    .catch(err=>{
        return err
    })
})

export const checkSbmit = createAsyncThunk('check/checkSubmit', async (data)=>{
    return Api.post(Api.routeEapp+MasterApi.checkSubmit, data)
    .then(response=>{
        return response
    })
    .catch(err=>{
        return err
    })
})

export const generateDocSubmit = createAsyncThunk('check/generateDocSubmit', async (data)=>{
    return Api.post(Api.routeEapp+MasterApi.generateDocSubmit, data)
    .then(response=>{
        return response
    })
    .catch(err=>{
        return err
    })
})

export const dmsIproposeSubmit = createAsyncThunk('check/dmsIproposeSubmit', async (data)=>{
    return Api.post(Api.routeEapp+MasterApi.dmsIproposeSubmit, data)
    .then(response=>{
        return response
    })
    .catch(err=>{
        return err
    })
})

export const submitBPM = createAsyncThunk('check/submitBPM', async (data)=>{
    return Api.post(Api.routeEapp+MasterApi.submitBPM, data)
    .then(response=>{
        return response
    })
    .catch(err=>{
        return err
    })
})

export const submitBPMFu = createAsyncThunk('check/submitBPMFu', async (data)=>{
    return Api.post(Api.routeEapp+MasterApi.submitBPMFu, data)
    .then(response=>{
        return response
    })
    .catch(err=>{
        return err
    })
})

export const ilustrationSignature = createSlice(({
    name:"IlustrationSignature",
    initialState:{
        Signature:[],
        loading:false
    },
    extraReducers:{
        [getIlustrationSignature.pending]: (state, action) => {
            state.loading = true
        },
        [getIlustrationSignature.fulfilled]: (state, action) => {
            state.loading = false
            state.Signature = action.payload.data
        }
    }
}))


export const Selfie = createSlice(({
    name:"IlustrationSignature",
    initialState:{
        Selfie:[],
        loading:false
    },
    extraReducers:{
        [getSelfie.pending]: (state, action) => {
            state.loading = true
        },
        [getSelfie.fulfilled]: (state, action) => {
            state.loading = false
            state.Selfie = action.payload.data
        }
    }
}))

export const Video = createSlice(({
    name:"Video",
    initialState:{
        Video:[],
        loading:false    
    },
    extraReducers:{
        [getVideos.pending]: (state, action) => {
            state.loading = true
        },
        [getVideos.fulfilled]: (state, action) => {
            state.loading = false
            state.Video = action.payload
        }
    }
}))